import ListOrderWidget from 'common/form/widgets/listOrder/ListOrderWidget';
import { iDef } from 'core/util/TypeUtils';
/**
 * @overview general utility class for subscriptions
 * @author chills
 */

export enum Completion {
	NotStarted = "NotStarted",
	Started = "Started",
	Incomplete = "Incomplete",
	Completed = "Completed",
	Passed = "Passed",
	Failed = "Failed"
}

const completions = Object.keys(Completion);

export enum Status {
	Active,
	Inactive,
	Expired,
	Deleted,
	Withdrawn,
	Candidate,
	Finished,
	Suspended
}

export function getCompletionPercent(sub: any) {
	if (!sub || !sub.completion) {
		return 0;
	}
	switch(sub.completion) {
		case Completion.Completed:
			return 1;
		case Completion.Passed:
			return 1;
		case Completion.Incomplete:
			return 0.5;
		case Completion.Started:
			return 0.5;
		default:
			return 0;
	}
}

export function isCompleted(sub: ISubscription): boolean {
	return !!sub && (sub.completion === Completion.Completed || sub.completion === Completion.Passed);
}

export interface ISubscription {
	id: string;
	completion?: Completion;
	product?: any;
	entry?: any;
	launchURL?: any;
}

export const sortOptions = [
	{value: "item.name", label: "Name", key: "item.name"},
	{value: "item.startDate", label: "Start Date", key: "item.startDate"},
	{value: "item.endDate", label: "End Date", key: "item.endDate"},
	{value: "lastVisited", label: "Last Accessed", key: "lastVisited"}
];

export const validateCompletions = (lst: string[]) => lst.filter((item) => completions.indexOf(item) > -1);

export const getSelectedSortOptions = (values: string[], defaultAll?: boolean) => {
	return values ? sortOptions.filter((o) => values.indexOf(o.value) > -1) : (defaultAll ? sortOptions : []);
};

export const validateSort = (value: string) => sortOptions.map((o) => o.value).indexOf(value) > -1 ? value : null;

export const sortOptionsInput = ListOrderWidget.registerWithOptions(sortOptions, true);

export class SubscriptionWrapper {
	protected sub: ISubscription;

	constructor(subscription: ISubscription) {
		this.sub = subscription;
	}

	public getCompletionPercent(): number {
		switch(this.sub.completion) {
			case Completion.Completed:
				return 1;
			case Completion.Passed:
				return 1;
			case Completion.Incomplete:
				return 0.5;
			case Completion.Started:
				return 0.5;
			default:
				return 0;
		}
	}

	public getCourseName(): string {
		return (this.sub.entry && this.sub.entry.displayName) || (this.sub.product && this.sub.product.name) || "";
	}

	public getLaunchUrl() {
		const launchDetails = this.sub.launchURL;

		if(iDef(launchDetails)) {
			const token = localStorage.getItem("token");
			return launchDetails.launchURL.concat("&token=", token);
		}
	}

	public getDetailsUrl() {
		const launchDetails = this.sub.launchURL;

		if(iDef(launchDetails)) {
			const token = localStorage.getItem("token");
			return launchDetails.viewURL.concat("&token=", token);
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/entities/Subscription.ts